import React, { useEffect, useState } from "react";
import Header from "./Header";
import FooterTwo from "./Footerthree";
import icon from "../images/mainLogo.png";
import AOS from "aos";


export default function Layout({ children }) {

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div  style={{ margin: `0 auto`, padding: `0`}}>
        <div id="overlay">
          <img src={icon} alt="Loading" />
        </div>

        <Header />
       {children}
        <FooterTwo/>
      </div>
    </>
  );
}
